import { Controller } from "stimulus";
export default class extends Controller {
  static targets = [
    "formProductCategory",
    "desktopFilterLink",
    "filterTotal",
    "productFrame",
    "productCount",
  ];

  productFrameTargetConnected(element) {
    this.productCountTarget.innerHTML = `${element.dataset.productCount} Products`;
  }

  selectCategory(event) {
    const categoryId = event.target.dataset.productcategoryid;
    this._updateLinkUrl(categoryId);
    this._updateUrl(categoryId);
    this._updateDesktopFilterLinks();
    this._updateFilterFormValue(categoryId);
    this._updateFilterTotal();
  }

  submitFilterForm() {
    this._updateUrlFromForm();
    this._updateDesktopFilterLinks();
    this._updateFilterTotal();
  }

  _updateLinkUrl(categoryId) {
    let key = this._categorykey(categoryId);
    for (const desktopFilterLink of this.desktopFilterLinkTargets) {
      let url = new URL(desktopFilterLink.href);
      if (this._categoryCurrentlySelected(categoryId)) {
        url.searchParams.set(key, "0");
      } else {
        url.searchParams.set(key, "1");
      }
      desktopFilterLink.href = url.href;
    }
  }

  _updateUrl(categoryId) {
    let url = new URL(location.href);
    let key = this._categorykey(categoryId);

    if (this._categoryCurrentlySelected(categoryId)) {
      url.searchParams.set(key, "0");
    } else {
      url.searchParams.set(key, "1");
    }

    history.pushState({}, "", url.href);
  }

  _updateUrlFromForm() {
    let url = new URL(location.href);
    let current_search = url.searchParams;

    for (const productCategory of this.formProductCategoryTargets) {
      let key = productCategory.name;
      if (productCategory.checked) {
        current_search.set(key, "1");
      } else {
        current_search.set(key, "0");
      }
    }

    history.pushState({}, "", url.href);
  }

  _categoryCurrentlySelected(categoryId) {
    let url = new URL(location.href);
    let key = this._categorykey(categoryId);
    let currentValue = url.searchParams.get(key);
    if (currentValue == "1") {
      return true;
    } else {
      return false;
    }
  }

  _updateDesktopFilterLinks() {
    for (const desktopFilterLink of this.desktopFilterLinkTargets) {
      let categoryId = desktopFilterLink.dataset.productcategoryid;
      if (this._categoryCurrentlySelected(categoryId)) {
        desktopFilterLink.classList.add("selected");
        desktopFilterLink.innerHTML = `X ${desktopFilterLink.dataset.productcategoryname}`;
      } else {
        desktopFilterLink.classList.remove("selected");
        desktopFilterLink.innerHTML =
          desktopFilterLink.dataset.productcategoryname;
      }
    }
  }

  _updateFilterFormValue(categoryId) {
    for (const productCategory of this.formProductCategoryTargets) {
      if (productCategory.name == this._categorykey(categoryId)) {
        if (this._categoryCurrentlySelected(categoryId)) {
          productCategory.checked = true;
        } else {
          productCategory.checked = false;
        }
      }
    }
  }

  _categorykey(categoryId) {
    return `[product_categories][${categoryId}]`;
  }

  _updateFilterTotal() {
    let newTotal = 0;

    for (const productCategory of this.formProductCategoryTargets) {
      if (productCategory.checked) {
        newTotal++;
      }
    }
    this.filterTotalTarget.innerHTML = newTotal;
  }
}
